import React from "react";

import "./Product.css";

export default ({ product, handleProductSelect }) => {
  return (
    <div className="thumbnail_box">
      <div className="image-view">
        <span>
          {product.name}
        </span>
        <a
          className="exhibit_view"
          href="#returnshowroom"
          data-custom_key={"product" + product.id}
          onClick={() => handleProductSelect(product.id)}
        >
          <img src={product.ShowroomProducts[0].thumbnailUrl} alt={product.name} />
          <p className="view_text">360度写真を見る</p>
        </a>
        {product.ShowroomProducts[0].detailsUrl
          ?
          <div className="pdf_link">
            <a target="_blank" href={product.ShowroomProducts[0].detailsUrl}>
              プラン詳細を見る
          </a>
          </div>
          : null
        }
        {product.ShowroomProducts[0].videoUrl
          ?
          <div className="video-link">
            <a target="_blank" href={product.ShowroomProducts[0].videoUrl}>
              展示商品説明動画を見る
          </a>
          </div>
          : null
        }
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Product/Product.js